import React from "react";
import styles from "./styles.modules.scss";

export const Accordion = ({
    title,
    body,
}: {
    title: string;
    body: React.ReactNode;
}) => {
    return (
        <details className={`accordion ${styles.accordion}`}>
            <summary className={`title ${styles.title}`}>
                <span className={`titleWrapper ${styles.titleWrapper}`}>
                    <span className={`arrow ${styles.arrow}`}></span>
                    <span>{title}</span>
                </span>
            </summary>
            <div className={`accordionContent ${styles.accordionContent}`}>
                {body}
            </div>
        </details>
    );
};
